import { CollectionSetUp } from '../pages/RevenueAndCollections/CollectionSetUp';
import {
  Currency,
  CurrencyCreate,
  CurrencyDetails,
  CurrencyEdit,
  CurrencyList,
} from '../pages/RevenueAndCollections/Currency';
import {
  Customer,
  CustomerCreate,
  CustomerDetails,
  CustomerEdit,
  CustomerList,
} from '../pages/RevenueAndCollections/Customers';
import { CustomerStatements } from '../pages/RevenueAndCollections/CustomerStatements';
import {
  EstimateAndQuote,
  EstimateAndQuoteCreate,
  EstimateAndQuoteDetails,
  EstimateAndQuoteDetailsPDF,
  EstimateAndQuoteEdit,
  EstimateAndQuoteList,
} from '../pages/RevenueAndCollections/EstimateAndQuote';
import {
  Invoice,
  InvoiceList,
  InvoiceCreate,
  InvoiceEdit,
  InvoiceDetails,
  InvoiceDetailsPDF,
} from '../pages/RevenueAndCollections/Invoices';
import {
  RecurringInvoice,
  RecurringInvoiceCreate,
  RecurringInvoiceEdit,
  RecurringInvoiceList,
} from '../pages/RevenueAndCollections/RecurringInvoice';
import { RevenueAndCollections } from '../pages/RevenueAndCollections/RevenueAndCollections';

export const revenueAndCollectionRoutes = {
  path: 'revenue-and-collections',
  element: <RevenueAndCollections />,
  children: [
    {
      path: 'customers',
      element: <Customer />,
      children: [
        { index: true, element: <CustomerList /> },
        { path: 'create', element: <CustomerCreate /> },
        { path: ':id', element: <CustomerDetails /> },
        { path: ':id/edit', element: <CustomerEdit /> },
      ],
    },
    {
      path: 'currency',
      element: <Currency />,
      children: [
        { index: true, element: <CurrencyList /> },
        { path: 'create', element: <CurrencyCreate /> },
        { path: ':id/edit', element: <CurrencyEdit /> },
        { path: ':id/details', element: <CurrencyDetails /> },
      ],
    },
    {
      path: 'recurring-invoices',
      element: <RecurringInvoice />,
      children: [
        {
          index: true,
          element: <RecurringInvoiceList />,
        },
        { path: 'create', element: <RecurringInvoiceCreate /> },
        { path: ':id/edit', element: <RecurringInvoiceEdit /> },
      ],
    },
    {
      path: 'invoices',
      element: <Invoice />,
      children: [
        {
          index: true,
          element: <InvoiceList />,
        },
        { path: 'create', element: <InvoiceCreate /> },
        { path: ':id/edit', element: <InvoiceEdit /> },
        { path: ':id', element: <InvoiceDetails /> },
        { path: ':id/pdf', element: <InvoiceDetailsPDF /> },
      ],
    },
    { path: 'customer-statements', element: <CustomerStatements /> },
    { path: 'collection-set-up', element: <CollectionSetUp /> },
    {
      path: 'estimates-and-quotes',
      element: <EstimateAndQuote />,
      children: [
        { index: true, element: <EstimateAndQuoteList /> },
        {
          path: 'create',
          element: <EstimateAndQuoteCreate />,
        },
        { path: ':id/edit', element: <EstimateAndQuoteEdit /> },
        { path: ':id', element: <EstimateAndQuoteDetails /> },
        { path: ':id/pdf', element: <EstimateAndQuoteDetailsPDF /> },
      ],
    },
  ],
};
